export const REDUCER_NAME = "instagramCreativeSlice";

// ==========================
// Create Creative DTO
// ==========================

export interface IinstagramCreativeCreateDTO {
  image: string; // uploaded image URL or image_hash
  name: string;
  message: string;
  title: string;
  link: string;
  type: "LEARN_MORE" | "SHOP_NOW" | "SIGN_UP" | "CONTACT_US" | "BOOK_NOW";
  valuelink: string;
}

// ==========================
// Creative Response DTO
// ==========================

export interface IinstagramCreativeDTO {
  id: string;
  image?: string;
  name?: string;
  message?: string;
  title?: string;
  link?: string;
  type?: string;
  valuelink?: string;
  created_time?: string;
}

// ==========================
// Creative Redux State
// ==========================

export interface IinstagramCreativeState {
  instagramCreativeList: IinstagramCreativeDTO[] | null;
  isLoading: boolean;
  errorMessage: string | null;
}
